import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, lazy } from "react";
import { useParams } from "react-router-dom";
import AppSidebarLayout from "../../components/AppSidebarLayout";
// Item 40: resuming an existing proposal, docked into the dashboard's content area (the label
// panel stays collapsed by default -- see AppSidebarLayout's defaultCollapsed).
const RemoteDiscoveryFlow = lazy(() => import("@coremind/client-proposals-ui").then((mod) => ({ default: mod.DiscoveryFlow })));
export default function ProposalsConversationPage() {
    const { id } = useParams();
    if (!id)
        return null;
    return (_jsx(AppSidebarLayout, { defaultCollapsed: true, children: _jsx(Suspense, { fallback: null, children: _jsx(RemoteDiscoveryFlow, { variant: "docked", resumeConversationId: id }) }) }));
}
